import { checkoutApi, type LiveCheckout } from './api';

/**
 * One reader of GET /workitems/checkouts/live for the Ways page (hs-pmo/ep43#35 h). Active now and
 * Runners both show it; each asked for its own copy on every poll and on every switch between them.
 * A read in flight is shared, and a read younger than `maxAgeMs` is reused.
 */
type Live = { at: string; cursor: string; items: LiveCheckout[] };

const last: Record<'plain' | 'worked', { at: number; value: Live } | null> = { plain: null, worked: null };
const pending: Record<'plain' | 'worked', Promise<Live> | null> = { plain: null, worked: null };

export function liveCheckouts(maxAgeMs: number, worked = false): Promise<Live> {
  const k = worked ? 'worked' : 'plain';
  const hit = last[k];
  if (hit && Date.now() - hit.at < maxAgeMs) return Promise.resolve(hit.value);
  if (!pending[k]) {
    pending[k] = checkoutApi.live(worked)
      .then((value) => { last[k] = { at: Date.now(), value }; return value; })
      .finally(() => { pending[k] = null; });
  }
  return pending[k] as Promise<Live>;
}
